import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
	selector: '[autoRowSpan]',
})
export class AutoRowSpanDirective implements AfterViewInit {
	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngAfterViewInit(): void {
		const height = this.el.nativeElement.offsetHeight;
		const rowHeight = 10;
		const span = Math.ceil(height / rowHeight);
		this.renderer.setStyle(this.el.nativeElement, 'grid-row-end', `span ${span}`);
	}
}
